
import { useState } from 'react';

export default function Questions() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'What makes Venezia Agency different from other OnlyFans management companies?',
      answer: 'We combine Caribbean warmth with world-class expertise. Our personalized approach means you\'re never just a number. We take time to understand your unique brand, create custom strategies, and provide dedicated support. Plus, our proven track record speaks for itself - we\'ve helped creators achieve an average 340% growth rate.'
    },
    {
      question: 'How quickly can I expect to see results?',
      answer: 'Most creators see noticeable improvements within the first 30 days, including increased engagement and subscriber growth. Significant revenue growth typically occurs within 60-90 days as we implement comprehensive strategies. However, results vary based on your starting point, content quality, and commitment to the process.'
    },
    {
      question: 'What percentage of my earnings does Venezia Agency take?',
      answer: 'Our pricing is transparent and performance-based. We offer three tiers: Starter (20%), Professional (25%), and Elite (30%) of your monthly revenue. This means we only succeed when you succeed. There are no hidden fees or upfront costs - we\'re invested in your growth.'
    },
    {
      question: 'Do I need to be an established creator to work with you?',
      answer: 'Not at all! We work with creators at all stages - from those just starting out to established accounts looking to scale. Our strategies are tailored to your current level and goals. Whether you have 10 subscribers or 10,000, we have the expertise to help you grow.'
    },
    {
      question: 'How do you ensure my privacy and content security?',
      answer: 'Privacy is our top priority. We use industry-leading security protocols, sign strict NDAs, and never share your personal information or content. All team members undergo thorough background checks and confidentiality training. Your content and identity are protected at every step.'
    },
    {
      question: 'What services are included in your management packages?',
      answer: 'Our packages include content strategy and planning, subscriber engagement management, analytics and reporting, social media management, marketing campaigns, and dedicated support. Higher tiers include additional services like professional content creation, brand partnerships, legal consulting, and a dedicated account manager.'
    },
    {
      question: 'Can I cancel my contract if I\'m not satisfied?',
      answer: 'Yes. While we\'re confident in our services, we offer flexible terms. Our contracts include a 30-day notice period for cancellation. We believe in earning your business every month through results, not locking you into long-term commitments you\'re unhappy with.'
    },
    {
      question: 'How involved do I need to be in the day-to-day management?',
      answer: 'That\'s up to you! Some creators prefer to be hands-on with content creation while we handle marketing and engagement. Others want us to manage everything. We\'re flexible and adapt to your preferred level of involvement. At minimum, we need your input on brand direction and content approval.'
    }
  ];

  return (
    <section id="questions" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-serif text-[#0F0F0F] mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-600 text-lg">Everything you need to know about working with us</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className={`rounded-2xl bg-[#F6C1A1]/20 overflow-hidden transition-all duration-300 ${openIndex === index ? 'shadow-lg' : 'shadow-sm'}`}
              style={{
                borderLeft: openIndex === index ? '4px solid #9B5E6B' : '4px solid transparent'
              }}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-[#F6C1A1]/30 transition-colors duration-300 cursor-pointer"
              >
                <h3 className="text-lg font-bold text-[#0F0F0F] pr-8">{faq.question}</h3>
                <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-2xl text-[#C77A5A] flex-shrink-0 transition-transform duration-300`}></i>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}
              >
                <div className="px-8 pb-6">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">Still have questions?</p>
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="text-[#C77A5A] font-semibold hover:text-[#9B5E6B] transition-colors duration-300 cursor-pointer whitespace-nowrap"
          >
            Contact us directly →
          </button>
        </div>
      </div>
    </section>
  );
}
